import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  documentType: '',
  documentNumber: '',
  balance: 0,
  beneficiaries: [],
  grecaptchaResponse: '',
  isComplete: false,
}

const estimatorSlice = createSlice({
  name: 'estimator',
  initialState,
  reducers: {
    setDocumentType: (state, action) => {
      state.documentType = action.payload
    },
    setDocumentNumber: (state, action) => {
      state.documentNumber = action.payload
    },
    setBalance: (state, action) => {
      state.balance = action.payload
    },
    setBeneficiaries: (state, action) => {
      state.beneficiaries = action.payload
    },
    setGrecaptchaResponse: (state, action) => {
      state.grecaptchaResponse = action.payload
    },
    reset: (state) => {
      state.documentType = '';
      state.documentNumber = '';
      state.balance = 0;
      state.beneficiaries = [];
      state.grecaptchaResponse = '';
      state.isComplete = false;
    },
    setIsComplete: (state, action) => {
      state.isComplete = action.payload
    },
  },
})

export const {
  setDocumentType,
  setDocumentNumber,
  setBalance,
  setBeneficiaries,
  setGrecaptchaResponse,
  setIsComplete,
  reset,
} = estimatorSlice.actions;

export default estimatorSlice.reducer;